import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { $ } from '../../../base/browser/dom.js';
export var BrowserClipboardService = /*#__PURE__*/function () {
  function BrowserClipboardService() {
    _classCallCheck(this, BrowserClipboardService);

    this.mapTextToType = new Map(); // unsupported in web (only in-memory)

    this.findText = ''; // unsupported in web (only in-memory)
  }

  _createClass(BrowserClipboardService, [{
    key: "writeText",
    value: function writeText(text, type) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var activeElement, textArea;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!type) {
                  _context.next = 3;
                  break;
                }

                this.mapTextToType.set(type, text);
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return navigator.clipboard.writeText(text);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                console.error(_context.t0);

              case 12:
                // Fallback to textarea and execCommand solution
                activeElement = document.activeElement;
                textArea = document.body.appendChild($('textarea', {
                  'aria-hidden': true
                }));
                textArea.style.height = '1px';
                textArea.style.width = '1px';
                textArea.style.position = 'absolute';
                textArea.value = text;
                textArea.focus();
                textArea.select();
                document.execCommand('copy');

                if (activeElement instanceof HTMLElement) {
                  activeElement.focus();
                }

                document.body.removeChild(textArea);
                return _context.abrupt("return");

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));
    }
  }, {
    key: "readText",
    value: function readText(type) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!type) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this.mapTextToType.get(type) || '');

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return navigator.clipboard.readText();

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                console.error(_context2.t0);
                return _context2.abrupt("return", '');

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));
    }
  }, {
    key: "readFindText",
    value: function readFindText() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.findText);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "writeFindText",
    value: function writeFindText(text) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.findText = text;

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return BrowserClipboardService;
}();